import CrossSell from '@/components/CrossSell/CrossSell'
import TripActivity from '@/components/TripActivity/TripActivity'
import { Box } from 'pcln-design-system'
import type { SearchProductList } from '../TripActivity/types'
import GroupedTrip from './GroupedTrip'
import type { TripGrouping as TripGroupingProps } from './types'

export default function TripGrouping({
  tripGroupingBooking,
  tripGroupingAbandonedSelection,
  defaultAbandonedSelection,
  isLandingPage,
  growthLoopAudiences,
}: TripGroupingProps) {
  // TODO: tidy up productType as part of WEB_HP_PACKAGE_SELECTIONS cleanup
  const tripActivityProductType = ['STAY', 'FLY', 'DRIVE', 'PKG'] as SearchProductList
  if (tripGroupingBooking) {
    if (tripGroupingAbandonedSelection) {
      return (
        <>
          <Box mb={4}>
            <GroupedTrip
              isLandingPage={isLandingPage}
              booking={tripGroupingBooking}
              abandonedSelection={tripGroupingAbandonedSelection}
            />
          </Box>
          <TripActivity
            productType={tripActivityProductType}
            pageName='homepage'
            shouldUseSmallerHeading
            abandonedSelectionData={defaultAbandonedSelection}
            hideAbandonedSelection
          />
        </>
      )
    }
    return (
      <>
        <Box mb={4}>
          <CrossSell booking={tripGroupingBooking} growthLoopAudiences={growthLoopAudiences} />
        </Box>
        <TripActivity
          productType={tripActivityProductType}
          pageName='homepage'
          shouldUseSmallerHeading
          abandonedSelectionData={defaultAbandonedSelection}
          hideAbandonedSelection={false}
        />
      </>
    )
  }

  return (
    <TripActivity
      productType={tripActivityProductType}
      pageName='homepage'
      shouldUseSmallerHeading={false}
      abandonedSelectionData={defaultAbandonedSelection}
      hideAbandonedSelection={Boolean(tripGroupingAbandonedSelection)}
    />
  )
}
